import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import {
  Observable,
  finalize,
} from 'rxjs';
import { Candidate } from '../../shared/models/candidate-model';
import { ConstantsService } from './constants.service';
import { Company } from '../../shared/models/company-model';
import { LoggingService } from './logging.service';
import { handleHttpError } from '../operators/http-error.operator';

@Injectable({
  providedIn: 'root',
})
export class StockDataService {
  constructor(
    private constantsSvc: ConstantsService,
    private http: HttpClient,
    private logger: LoggingService
  ) {}

  // Loading flag
  public readonly loading = signal(false);

  // Error message
  public readonly error = signal('');

  searchStocks(searchTerm: string): Observable<Company[]> {
    this.loading.set(true);
    let searchQuery = { query: searchTerm };
    const apiUrl = `${this.constantsSvc.api_stocks_search}`;

    return this.http.post<Company[]>(apiUrl, searchQuery).pipe(
      handleHttpError(
        this.logger,
        [] as Company[],
        'Error searching company by ticker:',
        () => this.error.set('Failed to load company by ticker')
      ),
      finalize(() => {
        this.loading.set(false);
      })
    );
  }

  getIndustries(): Observable<string[]> {
    const apiUrl = `${this.constantsSvc.api_stocks_industries}`;

    return this.http.get<string[]>(apiUrl).pipe(
      handleHttpError(
        this.logger,
        [] as string[],
        'Error loading industries:',
        () => this.error.set('Failed to load industries')
      )
    );
  }

  getSectors(industry?: string): Observable<string[]> {
    const apiUrl = `${this.constantsSvc.api_stocks_sectors}`;
    const normalizedIndustry = industry?.trim() ?? '';

    if (normalizedIndustry) {
      return this.http.post<string[]>(apiUrl, { industry: normalizedIndustry }).pipe(
        handleHttpError(
          this.logger,
          [] as string[],
          'Error loading sectors for industry:',
          () => this.error.set('Failed to load sectors')
        )
      );
    }

    return this.http.get<string[]>(apiUrl).pipe(
      handleHttpError(
        this.logger,
        [] as string[],
        'Error loading sectors:',
        () => this.error.set('Failed to load sectors')
      )
    );
  }
}
